import type React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isNil } from 'lodash-es';
import useTimezone from '../../hooks/useTimezone';
import { setSearchSelection } from '../../redux/ducks/StorageDucks';
import type { RootReducerType } from '../../redux/reducers/RootReducer.types';

type Props = {
  children: React.ReactNode;
};

const SearchProvider = ({ children }: Props) => {
  const dispatch = useDispatch();
  const { currentTimezone } = useTimezone();

  const { searchSelection } = useSelector(
    (state: RootReducerType) => state.storage,
  );

  useEffect(() => {
    // Check time validity
    const now = new Date().getTime();
    if (
      !isNil(searchSelection) &&
      !isNil(searchSelection.time?.endTime) &&
      searchSelection.time.endTime < now
    ) {
      const newSearchSelection = {
        ...searchSelection,
        time: { timezone: currentTimezone },
      };
      dispatch(setSearchSelection(newSearchSelection));
    }
  }, [searchSelection]);

  return children;
};

export default SearchProvider;
